import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "calendar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Calendar", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "ID:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Description:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Expected Start:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Expected Conclusion:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Started:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Concluded:", -1)

import { onMounted, computed, ref } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { useCalendarStore } from '@/stores/Calender';
import Modal from '@/components/Modal.vue';
import DateTimeBadge from '@/components/DateTimeBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Calender',
  setup(__props) {

const calendarStore = useCalendarStore();
const selectedEventDetails = ref(null);
const showModal = ref(false);
const selectedEvent = ref(null);

const handleEventClick = (clickInfo) => {
  const { description, type, isReminder, expected_start, expected_concluded, started, completed } = clickInfo.event.extendedProps;

  const prefix = type.charAt(0).toUpperCase() + type.slice(1); // 
  let title = `${prefix}`;
  if (isReminder) {
    title += ` Reminder: ${clickInfo.event.title}`;
  } else {
    title += `: ${clickInfo.event.title}`;
  }

  selectedEvent.value = {
    title,
    bodyText: description,
    id: clickInfo.event.id,
    name: clickInfo.event.title,
    description: description,
    expected_start: clickInfo.event.expected_start,
    expected_concluded: clickInfo.event.expected_concluded,
    started: clickInfo.event.started,
    concluded: clickInfo.event.completed
  };

  showModal.value = true;
  console.log(clickInfo.event);
};



const calendarOptions = computed(() => {
  let allEventsAndReminders = [];

  calendarStore.events.forEach(event => {
    allEventsAndReminders.push(event);

    if (event.type === 'task') {
      if (event.expected_start) {
        const startReminder = {
          ...event,
          id: `start-${event.id}`,
          title: `Start Reminder: ${event.title}`,
          start: event.expected_start,
          end: event.expected_start,
          color: 'yellow',
          isReminder: true,
        };
        allEventsAndReminders.push(startReminder);
      }
      if (event.expected_concluded) {
        const concludeReminder = {
          ...event,
          id: `conclude-${event.id}`,
          title: `Conclude Reminder: ${event.title}`,
          start: event.expected_concluded,
          end: event.expected_concluded,
          color: 'yellow',
          isReminder: true,
        };
        allEventsAndReminders.push(concludeReminder);
      }
    }
  });

  return {
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,listWeek'
    },
    editable: true,
    selectable: true,
    weekends: true,
    themeSystem: 'bootstrap5',
    views: {
      dayGridMonth: {
        dayMaxEventRows: 3
      }
    },
    eventContent: (args) => {
      let eventClass = args.event.extendedProps.type === 'job' ? 'event-job' : 'event-task';
      if (args.event.extendedProps.isReminder) {
        eventClass += ' event-reminder';
      }
      return {
        html: `<div class="fc-event-custom ${eventClass}">
               <div class="fc-event-title">${args.event.title}</div>
             </div>`
      };
    },
    events: allEventsAndReminders,
    eventClick: handleEventClick,
  };
});

onMounted(() => {
  calendarStore.fetchEvents()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_unref(FullCalendar), { options: calendarOptions.value }, null, 8, ["options"]),
      (showModal.value)
        ? (_openBlock(), _createBlock(Modal, {
            key: 0,
            title: selectedEvent.value.title,
            show: showModal.value,
            "onUpdate:show": _cache[0] || (_cache[0] = value => showModal.value = value)
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(selectedEvent.value.id), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(selectedEvent.value.name), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(selectedEvent.value.description), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_8,
                  _createVNode(DateTimeBadge, {
                    time: selectedEvent.value.expected_start
                  }, null, 8, ["time"])
                ]),
                _createElementVNode("li", null, [
                  _hoisted_9,
                  _createVNode(DateTimeBadge, {
                    time: selectedEvent.value.expected_concluded
                  }, null, 8, ["time"])
                ]),
                _createElementVNode("li", null, [
                  _hoisted_10,
                  _createVNode(DateTimeBadge, {
                    time: selectedEvent.value.started
                  }, null, 8, ["time"])
                ]),
                _createElementVNode("li", null, [
                  _hoisted_11,
                  _createVNode(DateTimeBadge, {
                    time: selectedEvent.value.concluded
                  }, null, 8, ["time"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title", "show"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})